/**
 * The DOM ids of the security page's cards that another card points at: the SCIM card sends the
 * admin to whatever its prerequisites or its hints are about.
 */
export const SECURITY_CARD_ANCHORS = {
  ssoVerifiedDomains: 'sso-verified-domains',
  ssoStatus: 'sso-status',
  ssoProvisioning: 'sso-provisioning',
  scimProvisioning: 'scim-provisioning',
} as const;

export type SecurityCardAnchor =
  (typeof SECURITY_CARD_ANCHORS)[keyof typeof SECURITY_CARD_ANCHORS];
